import { Button, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import AvatarEditor from "react-avatar-editor";

import {
  WrapActionBtn,
  WrapImageCropper,
  WrapImageCtlBtn,
} from "./index.styled";

const ImageCropper = (props) => {
  // 총 너비의 80% 를 편집창으로 활용하려고 한다.
  const viewPortWidth = document.body.clientWidth * 0.71;
  const { file, originWidth, originHeight, itemId, shape, sno } =
    props.imageInfo;

  const [imageScale, setImageScale] = useState(1.2);
  const [processLoading, setProcessLoading] = useState(false);
  const [rotate, setRotate] = useState(0);

  const ratio = viewPortWidth / originWidth;

  useEffect(() => {
    return () => {
      setRotate(0);
      setImageScale(1.2);
    };
  }, [file]);

  const editorRef = useRef();

  const applyImage = () => {
    setProcessLoading(true);
    setTimeout(() => {
      if (editorRef) {
        const imgSrcData = (editorRef.current! as any).getImage().toDataURL();

        (
          document.getElementById(
            `${sno}-${itemId}_target_image`
          ) as HTMLImageElement
        ).src = imgSrcData;
        setProcessLoading(false);
        props.submitCallback(imgSrcData);
      }
    }, 500);
  };

  let borderRadius = 0;

  switch (shape) {
    case "square":
      borderRadius = 0;
      break;
    case "circle":
      borderRadius = 200;
      break;
    default:
      borderRadius = 0;
  }

  return (
    <WrapImageCropper>
      <Spin spinning={processLoading}>
        <AvatarEditor
          image={file}
          ref={editorRef as any}
          width={Math.floor(viewPortWidth)}
          height={Math.floor(originHeight * ratio)}
          border={50}
          color={[0, 0, 0, 0.6]} // RGBA
          scale={imageScale}
          rotate={rotate}
          borderRadius={borderRadius}
        />
        <WrapImageCtlBtn>
          <Button
            type="ghost"
            icon="zoom-in"
            onClick={() => {
              if (imageScale + 0.1 <= 10) {
                setImageScale(imageScale + 0.1);
              }
            }}
          >
            확대
          </Button>
          <Button
            type="ghost"
            icon="zoom-out"
            onClick={() => {
              if (imageScale - 0.1 >= 0.5) {
                setImageScale(imageScale - 0.1);
              }
            }}
          >
            축소
          </Button>

          <Button
            type="ghost"
            onClick={() => {
              setRotate(rotate + 90 >= 360 ? 0 : rotate + 90);
            }}
            icon="redo"
          >
            90도돌려
          </Button>
          <Button
            type="ghost"
            onClick={() => {
              setRotate(rotate + 90 >= 360 ? 0 : rotate + 1);
            }}
            icon="redo"
          >
            오른쪽으로 쪼끔돌려
          </Button>
          <Button
            type="ghost"
            onClick={() => {
              setRotate(rotate + 90 >= 360 ? 0 : rotate - 1);
            }}
            icon="redo"
          >
            왼쪽으로 쪼끔돌려
          </Button>
        </WrapImageCtlBtn>
        <WrapActionBtn>
          <Button type="primary" onClick={applyImage}>
            이미지확정!
          </Button>
          <Button type="dashed" onClick={() => props.closeCallback()}>
            취소
          </Button>
        </WrapActionBtn>
      </Spin>
    </WrapImageCropper>
  );
};

export default ImageCropper;



// WEBPACK FOOTER //
// ./src/components/imageCropper/index.tsx